var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIonicIosChatboxes = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.998,
    height: 15.005,
    viewBox: "0 0 14.998 15.005",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-chatboxes",
    "data-name": "Icon ionic-ios-chatboxes",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_5",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 5",
    d: "M20.427,11.981H12.968a1.284,1.284,0,0,0-1.282,1.282v5.193a1.281,1.281,0,0,0,1.282,1.279h4.268a.368.368,0,0,1,.256.108l2.12,1.955c.118.114.313.067.313-.1V20c0-.2.128-.266.33-.266h.034a1.4,1.4,0,0,0,1.417-1.279v-5.19A1.277,1.277,0,0,0,20.427,11.981Z",
    transform: "translate(-7.708 -7.862)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_6",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 6",
    d: "M7.629,6.67H13.6v-2.2a1.1,1.1,0,0,0-1.1-1.1H4.472a1.1,1.1,0,0,0-1.1,1.1v5.56a1.1,1.1,0,0,0,1.1,1.1H6.529V7.767A1.1,1.1,0,0,1,7.629,6.67Z",
    transform: "translate(-3.375 -3.375)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIonicIosChatboxes, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ionic-ios-chatboxes.912f1739.svg";
export { ForwardRef as ReactComponent };